module.exports = __webpack_public_path__ + "media/media/values/michael-semenov-479c4b692f86d8c15c0a7d213e5481fa.jpg";